import React from "react";
import { useHierarchyService } from "../../hooks/useHierarchyService";
import { Medication } from "../../constants/ProIcons";
import _ from 'lodash'

const ProClientMedication = ({id, assignment, performAction, totalAssignments})=>{
    
    const {data:{selectedTreeNode}} = useHierarchyService();
    const node = selectedTreeNode;
  
    if(_.get(assignment.occupantType, "code") === "CLIENT" && _.get(assignment.client, "hasClientMedications")){
        return  <div id={`medication-${id}`} className={_.gt(totalAssignments, 1)?_.isEqual(id+1, totalAssignments)?"p-mb cursor-pointer" :"p-mb-1 cursor-pointer":"p-mb cursor-pointer"}>
            <i className ={assignment.latestAssignment?"fas": "fas icon-opacity-low"} aria-hidden="true"  
              style={{ color: 'red', fontSize: 14, position: 'relative' }} onClick={()=>performAction(node, assignment, "CLIENT_MEDICATION", 'Client Medications', 'bottom')}>
                <Medication/>
            </i>
        </div> 
    }else {
        return <div id={`medication-${id}`} className="p-mb-5"></div>
    }          

}


export default ProClientMedication;